function metric(eventName, params) {
    // @ts-ignore dataLayer is added by Google Analytics
    if (window.dataLayer) {
        let pushArguments = ["event", eventName, params];
        gtag.apply(null, pushArguments);
    }
}
function gtag(...args) {
    // @ts-ignore dataLayer is added by Google Analytics
    if (window.dataLayer) {
        // @ts-ignore dataLayer is added by Google Analytics
        window.dataLayer.push(arguments);
    }
}
export { metric, gtag };
